import { Avatar, Grid, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { Exit, WhiteExit } from 'Images';
import { isSafari } from 'react-device-detect';

interface IProps {
  onClose: () => void;
  requestNumber?: string;
}

export const DialogTitleContent = (props: IProps) => {
  const isDesktop = useIsDesktop();

  const dictionary = useDictionary(Dictionary, DICTIONARY.Equipment);
  const generalDictionary = useDictionary(Dictionary, DICTIONARY.General);

  const titleTextStyle = {
    display: 'inline',
    lineHeight: isDesktop ? '' : '18px',
    color: isDesktop ? 'white' : '#39546A',
    fontSize: isDesktop ? '22px' : '24px',
    alignSelf: isDesktop ? '' : 'flex-end',
  };

  return (
    <Grid
      container
      direction={'row'}
      alignItems={'center'}
      justifyContent={'space-between'}
      sx={{ height: '100%' }}
      mb={2}
    >
      <Typography
        variant='h2'
        sx={{
          alignSelf: isDesktop ? '' : 'flex-end',
        }}
      >
        <Typography sx={titleTextStyle}>
          {`${dictionary.orderDialog.orderNum}: `}
        </Typography>
        <Typography
          sx={{
            ...titleTextStyle,
            color: isDesktop ? '#FFF' : '#1752AF',
            fontWeight: 700,
          }}
        >
          {props.requestNumber
            ? props.requestNumber
            : dictionary.orderDialog.willBeSettledLater}
        </Typography>
      </Typography>
      <Avatar
        component={'button'}
        alt={
          generalDictionary.closeWindow +
          ' ' +
          dictionary.orderDialog.returnToEquipment
        }
        src={isDesktop ? WhiteExit : Exit}
        onClick={props.onClose}
        sx={{
          cursor: 'pointer',
          alignSelf: isDesktop ? '' : 'flex-start',
          top: !isDesktop && isSafari ? '30px' : '',
          border: 'none',
          background: 'transparent',
          width: '18px',
          height: '18px',
          padding: 0,
        }}
      />
    </Grid>
  );
};
